export function checkEmail(email) {
  const emailToValidate = email ? email : "";
  const emailRegexp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const res = emailRegexp.test(emailToValidate);
  return res;
}

export function checkName(name) {
  const nameToValidate = name ? name : "";
  const nameRegexp = /^[A-Za-z]+(?:[ _-][A-Za-z]+)*$/;
  const res = nameRegexp.test(nameToValidate);
  return res;
}

export function checkDob(dob) {
  const dobToValidate = dob ? dob : "";
  const dobRegexp =
    /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
  const res = dobRegexp.test(dobToValidate);
  return res;
}

export function checkPassword(password) {
  const passwordToValidate = password ? password : "";
  const passwordRegexp =
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@_*&.#~^_|\\$€₹¥£])[A-Za-z\d@_*&.#~^_|\\$€₹¥£]{8,15}$/;
  // /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@_*&.#])[A-Za-z\d@_*&.#]{8,15}$/;
  const res = passwordRegexp.test(passwordToValidate);
  return res;
}

export function checkOtp(otp) {
  const otpToValidate = otp ? otp : "";
  const otpRegexp = /^[0-9]*$/;
  const res = otpRegexp.test(otpToValidate);
  return res;
}

export function sortByPair(data, asc = true, setData) {
  let result;
  if (asc)
    result = data.sort((a, b) => {
      let x = a.symbol.toLowerCase();
      let y = b.symbol.toLowerCase();
      if (x < y) {
        return -1;
      }
      if (x > y) {
        return 1;
      }
      return 0;
    });
  else
    result = data.sort((a, b) => {
      let x = a.symbol.toLowerCase();
      let y = b.symbol.toLowerCase();
      if (x < y) {
        return 1;
      }
      if (x > y) {
        return -1;
      }
      return 0;
    });
  setData(result);
}
export function sortByVol(data, asc = true, setData) {
  let result;
  if (asc)
    result = data.sort((a, b) => {
      let x = a.volume_24h;
      let y = b.volume_24h;
      if (x < y) {
        return -1;
      }
      if (x > y) {
        return 1;
      }
      return 0;
    });
  else
    result = data.sort((a, b) => {
      let x = a.volume_24h;
      let y = b.volume_24h;
      if (x < y) {
        return 1;
      }
      if (x > y) {
        return -1;
      }
      return 0;
    });
  setData(result);
}
export function sortByChange(data, asc = true, setData) {
  let result;
  if (asc)
    result = data.sort((a, b) => {
      let x = a.price_change_percentage_24h;
      let y = b.price_change_percentage_24h;
      if (x < y) {
        return -1;
      }
      if (x > y) {
        return 1;
      }
      return 0;
    });
  else
    result = data.sort((a, b) => {
      let x = a.price_change_percentage_24h;
      let y = b.price_change_percentage_24h;
      if (x < y) {
        return 1;
      }
      if (x > y) {
        return -1;
      }
      return 0;
    });
  setData(result);
}

export function getCoinRate(coins, coin) {
  let coins1 = Object.values(coins);
  let res = coins1.find((d) => d.symbol === coin);

  if (!res || isNaN(res.current_price)) {
    return 0;
  }
  let price = Math.round(res.current_price * 10000) / 10000;
  return price !== 0
    ? price
    : Math.round(res.current_price * 100000000) / 100000000;
}

export function getRound(balance) {
  const value = Number(balance);
  if (!Number.isFinite(value)) return 0;
  return Math.round(value * 10000) / 10000 != 0
    ? Math.round(value * 10000) / 10000
    : Math.round(value * 100000000) / 100000000;
}

export function getWalletUsdBalance(item) {
  if (!item) return 0;
  return Number(
    item.usdBalance ?? item.usdtBalance ?? item.total_combine_balance ?? 0
  );
}

export function getWalletDisplayBalance(item) {
  if (!item) return 0;

  const balance = Number(item.balance || 0);
  const locked = Number(item.locked || 0);
  const total = balance + locked;

  if (total > 0) {
    return total;
  }

  const usdValue = getWalletUsdBalance(item);
  const price = Number(item.usdPrice ?? item.usdtPrice ?? 0);

  if (usdValue > 0 && price > 0) {
    return usdValue / price;
  }

  return balance;
}

function getWalletFractionDigits(value) {
  const abs = Math.abs(Number(value));
  if (!Number.isFinite(abs) || abs === 0) return 0;
  if (abs < 0.0001) return 8;
  if (abs < 0.01) return 6;
  if (abs < 1) return 5;
  if (abs < 100) return 4;
  return 2;
}

export function formatWalletAmount(value, locales = "en-US") {
  const num = Number(value);
  if (!Number.isFinite(num) || num === 0) return "0";

  return new Intl.NumberFormat(locales, {
    minimumFractionDigits: 0,
    maximumFractionDigits: getWalletFractionDigits(num),
  }).format(num);
}
